/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import ko from 'knockout';
import jobUtil from '../../objects/jobUtil';
import utils from '../../objects/utils';

//import axios from 'axios';
import $ from 'jquery';

class jdmModalModel {

    constructor() {
        // Profile
        this.componentName = ko.observable("jdm-modal");
        this.context = context;
        this.utils = utils;
        this.id = this.context.util.guid();
        this.visible = ko.observable(true);

        this.mode = ko.observable("standard");

        this.searchView = ko.observable(false);
        this.searchTerm = ko.observable();
        this.searchArray = ko.observableArray([]);
        this.searchError = ko.observable(false);

        this.selectAll = ko.observable(false);

        this.occ = ko.observable('');
        this.componentArray = ko.observableArray([]);
        
        this.callingComponent;

        this.appendAndReplaceVisible = ko.computed(arg => {

            if( (this.mode() != 'new') && (this.componentArray().length !== 0) )
            {
                return true;
            }
            else
            {
                return false;
            }

        });

        this.saveNewJobVisible = ko.computed( arg => {

            if( (this.mode() == 'new') && (this.componentArray().length !== 0) )
            {
                return true;
            }
            else
            {
                return false;
            }

        });

        ko.components.register('percentage-widget', require('../job-create/sub/percentage-widget').default);
        ko.components.register('jdm-widget', require('../job-create/sub/jdm-widget').default);
    
        console.log('jdm-modal:constructor  this: %o', this);
        

        this.context.eventManager.subscribe((ImportJDMObj) =>{
            this.showModal(ImportJDMObj);
        },this, "Show JDM-Modal");

    }

    showModal(ImportJDMObj) {
        
        console.log("jdm-modal:showModal: %o type: %s", ImportJDMObj, ImportJDMObj.type);

        if(ImportJDMObj.type == "new")
        {
            this.searchTerm("");
            this.reset("");
            this.mode("new");
            console.log("jdm-modal:showModal:  New Job Process");
            $('#jdmModal').modal('show');
            this.utils.scrollToTop("#jdmModal");
            //this.searchView(false);
            
            if(typeof ImportJDMObj.job !== "undefined")
            {
                if(typeof ImportJDMObj.job.onetsoc_code !== "undefined")
                {
                    this.init(ImportJDMObj.job.onetsoc_code);
                }
            }
            
            
            this.searchView(false);
            this.searchView.valueHasMutated();
        }
        else
        {
            this.mode("standard");
            this.callingComponent = ImportJDMObj.callingComponent;
            this.reset(false);
            $('#jdmModal').modal('show');
            this.utils.scrollToTop("#jdmModal");
            //console.log(ImportJDMObj.callingComponent);
    
            try{
                this.searchTerm(this.callingComponent.title());
            }
            catch(err)
            {
                this.searchTerm("");
            }
            
    
            if(this.searchTerm().length > 3)
            {
                this.searchJob();
                this.searchView(false);
            }
        }
        

    }

    reset(clearSearchTerm) {

        console.log('jdm-modal:reset: clearSearchTerm: %o', clearSearchTerm);
        
        this.searchArray([]);
        this.componentArray([]);
        this.searchView(true);

        if(clearSearchTerm)
        {
            this.searchTerm("");
        }
        
    }

    toggleView()
    {
        this.searchView(!this.searchView());
    }

    processSelectAll()
    {
        let self = this;
        ko.utils.arrayForEach(this.componentArray(), function(item) {
            
            let itemModel = $('#' + item.id );
            let thisWidget = ko.dataFor(itemModel[0]);

            thisWidget.include(self.selectAll())
        });

        this.selectAll(!this.selectAll());
    }

    init(occ) {
        
        console.log("jdm-modal:init");
        console.log(occ);
        this.componentArray([]);
        
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:0, editable: false, editableItems: false, title:"Title", apiFunction: "getSummary", occ: occ});
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:2, editable: false, editableItems: false, title:"Summary", apiFunction: "getSummary", occ: occ});
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:3, editable: true, editableItems: false, title:"Abilities", apiFunction: "getAbilities", occ: occ });
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:4, editable: true, editableItems: false, title:"Tasks", apiFunction: "getTasks", occ: occ });
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:5, editable: true, editableItems: true, title:"Technology", apiFunction: "getTechnology", occ: occ});
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:6, editable: true, editableItems: true, title:"Tools", apiFunction: "getTools", occ: occ});
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:7, editable: true, editableItems: false, title:"Knowledge", apiFunction: "getKnowledge", occ: occ});
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:8, editable: true, editableItems: false, title:"Skills", apiFunction: "getSkills", occ: occ});
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:9, editable: true, editableItems: false, title:"Work Activities", apiFunction: "getWorkActivities", occ: occ});
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:10, editable: true, editableItems: false, title:"Work Context", apiFunction: "getWorkContext", occ: occ});
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:11, editable: true, editableItems: false, title:"Work Styles", apiFunction: "getWorkStyles", occ: occ});
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:12, editable: true, editableItems: false, title:"Work Values", apiFunction: "getWorkValues", occ: occ});
        this.componentArray.push({component:"jdm-widget", id:context.util.guid(), index:13, editable: true, editableItems: false, title:"Interests", apiFunction: "getIterests", occ: occ});

        this.componentArray.push({component:"percentage-widget", id:context.util.guid(), index:1, editable: true, editableItems: false, title:"Physical Demands", apiFunction: "physical", occ: occ});
        
    }

    searchJob() {

        //let callData = JSON.stringify({"serviceName":"BLR_Job_Description_Service", "methodName":"searchForJob","parameters":[this.searchTerm()]});

        //let filter = encodeURI(JSON.stringify({ "where" : { "subid" : context.subid()}, "order": "positiontitle"}));
        let url = context.generateApiUrl('/Jobs/job/searchForJob');
        let callData = JSON.stringify({"searchTerm": this.searchTerm()});
        
        console.log('jdm-modal:searchJob:  searchTerm: %o', this.searchTerm());
        
        //Clear Job List
        this.searchArray([]);
        this.componentArray([]);
        this.searchError(false);

        $.ajax({
            url: url,
            method: "post",
            headers: this.context.apiContentType,
            data: callData
        })
          .done((response, textResponse, request) => {
            console.log('jdm-modal:searchJob:  response: %o', response.data);
            this.searchView(true);
            this.searchArray(response.data);
            console.log('jdm-modal:searchJob:  this.searchArray: %o', this.searchArray());
            if(this.searchArray())
            {
                console.log('jdm-modal:searchJob:  searchArray is valid test. ');
                if(this.searchArray().length == 0)
                {
                    console.log('jdm-modal:searchJob:  searchArray has a Zero length');
                    this.searchError(true);
                }
                else
                {
                    console.log('jdm-modal:searchJob:  searchArray has a Non-Zero length.');
                }
            }
            
          })
          .fail((errorThrown, other1) => {
            console.log("jdm-modal:searchJob Error:");
            console.log(errorThrown);
            this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Jdm-Modal: Error searching for Job"},"messageModel");
          });

    }

    jobSelected(item,parent) {

        console.log("jdm-modal:jobSelected  item: %o, parent: %o", item, parent);
        console.log(item);

        parent.searchView(false);
        parent.init(item.onetsoc_code);
    }


    handleMoveUp(item)
    {
        console.log("jdm-modal:MoveUp");
        console.log(item);
        console.log(this.indexOf(item.index));
        this.sortComponentArray();
        console.log(this.componentArray.indexOf())
    }

    handleMoveDown(item)
    {
        console.log("jdm-modal:MoveDown");
        console.log(item);
        console.log(this.indexOf(item.index));
        this.sortComponentArray();
    }

    sortComponentArray()
    {
        this.componentArray.sort(function (left,right) {
            return left.index < right.index ? 0 : 1;
        });
    }

    indexOf(selectedIndex)
    {
        console.log("jdm-modal:indexOf");

        let currentIndex = 0;

        console.log("indexOf: " + selectedIndex());

        ko.utils.arrayForEach(this.componentArray(), function(item) {

            console.log('jdm-modal: indexOf item: %o  Current Index: %o ', item,  currentIndex);

            if(Number(item.index) == item.numselectedIndex())
            {
                return currentIndex
            }

            currentIndex = currentIndex + 1;
        });

        return -1;
    }

    getContent() {

        let NewContent = "";
        //Loop and get content
        ko.utils.arrayForEach(this.componentArray(), function(item) {

            console.log(item);
            let itemModel = $('#' + item.id );
            let thisWidget = ko.dataFor(itemModel[0]);

            console.log(thisWidget);
            console.log(thisWidget.content());

            if(thisWidget.include())
            {
                NewContent = NewContent + "<br>" + thisWidget.content();
            }
            
        });

        return NewContent;
    }

    importJob(append) {

        console.log("jdm-modal:importJob");

        let NewContent = this.getContent();

        if(append)
        {
            this.callingComponent.editorBody(this.callingComponent.editorBody() + " <br> " + NewContent);
        }
        else
        {
            this.callingComponent.editorBody(NewContent);
        }
        
        $('#jdmModal').modal('hide');
        this.searchView(true);
    }

    
    saveNewJob() {

        console.log('jdm-modal:saveNewJob: context: %o', this.context );
        
        let title = $('#jdmModal h1:first').html();
        //alert(title);

        let jobUtilObj = new jobUtil(this.context);
        jobUtilObj.saveDefaultJob(title, this.getContent());

        $('#jdmModal').modal('hide');

    }

}

export default { viewModel: jdmModalModel, template: require('!raw-loader!./jdm-modal.html') };


// WEBPACK FOOTER //
// ./src/components/job-create/jdm-modal.js